import fetch from '@/utils/fetch';
import { SCHEDULE_TYPE_MAP, GET_STAFF_PARAM } from './type';

const model = {
  state: {
    cacheTime: -1,
    cacheKey: '0',
    scheduleSearchParams: { page: 1, pageSize: 10 },
    arrangeSearchParams: { page: 1, pageSize: 10 },
    overviewSearchParams: { page: 1, pageSize: 10 },
    scheduleList: [],
    scheduleListTotal: 0,
    arrangeScheduleList: [],
    arrangeScheduleListTotal: 0,
    serverTime: Date.now(),
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { schedule }, getState }: any) => ({
    initArrangeSearchInfo() {
      schedule.setState({
        arrangeScheduleList: [],
        arrangeScheduleListTotal: 0,
        arrangeSearchParams: { page: 1, pageSize: 10 },
      });
    },
    async getScheduleList(params = {}) {
      const scheduleSearchParams = { ...getState().schedule.scheduleSearchParams, ...params };
      const data = await fetch('/saasmerchant/fsarea/businessSchedule/manage', {
        params: scheduleSearchParams,
      });
      schedule.setState({
        scheduleList: (data && data.list) || [],
        scheduleSearchParams,
        scheduleListTotal: (data && data.total) || [],
      });
    },
    async getScheduleArrangeList(params = {}) {
      const arrangeSearchParams = { ...getState().schedule.arrangeSearchParams, ...params };
      const data = await fetch('/saasmerchant/fsarea/businessSchedule/businessScheduleList', {
        params: arrangeSearchParams,
      });
      schedule.setState({
        arrangeScheduleList: (data && data.list) || [],
        arrangeScheduleListTotal: data?.total,
        arrangeSearchParams,
      });
    },
    async addScheduleArrange(params = {}) {
      const data = await fetch('/saasmerchant/fsarea/businessSchedule/create', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
      return data;
    },
    async updateScheduleArrange(params = {}) {
      const data = await fetch('/saasmerchant/fsarea/businessSchedule/update', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
      return data;
    },
    async deleteScheduleArrange(params = {}) {
      const data = await fetch('/saasmerchant/fsarea/businessSchedule/delete', {
        params,
        type: 'POST',
        useJson: true,
      });
      return data;
    },
    async getScheduleDetail(id: string) {
      const data = await fetch('/saasmerchant/fsarea/businessSchedule/detail', {
        params: { scheduleId: id },
      });
      return data;
    },
    async getArrangeStaff(params: GET_STAFF_PARAM) {
      const res = await fetch('/saasmerchant/fsarea/employee/businessDistrictEmployee', {
        params: params || {},
        getAllResponseData: true,
      });
      schedule.setState({
        serverTime: res.st,
      });
      return res.data;
    },
    async getScheduleOverviewData(params = {}) {
      const overviewSearchParams = { ...getState().schedule.overviewSearchParams, ...params };
      const data = await fetch('/saasmerchant/fsarea/businessSchedule/employeeScheduleView', {
        params: overviewSearchParams,
        getAllResponseData: true,
      });
      schedule.setState({
        overviewSearchParams,
      });
      return data;
    },
    async adjustScheduleView(params = {}) {
      const resData = fetch('/saasmerchant/fsarea/businessSchedule/changeEmployeeScheduleView', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
      return resData;
    },
    async exportSchedule(params) {
      const data = fetch('/saasmerchant/fsarea/businessSchedule/exportBusinessSchedule', {
        params,
        type: 'POST',
        useJson: true,
      });
      return data;
    },
    setCacheKey(key) {
      schedule.setState({
        cacheKey: key,
      });
    },
    setCacheTime(time) {
      schedule.setState({
        cacheTime: time,
      });
    },
  }),
};

export const SCHEDULE_TYPE = [
  { value: SCHEDULE_TYPE_MAP.DELIVERY, label: '配送排班' },
  { value: SCHEDULE_TYPE_MAP.SERVICE, label: '分餐排班' },
];

export default model;
